module.exports = __webpack_public_path__ + "img/book_cover_full_width.7dbf3a4c.jpg";